export const preventClickPropagation = (
  e: React.MouseEvent<HTMLElement, MouseEvent> | any
) => {
  e.preventDefault();
  e.stopPropagation();
  e.nativeEvent.stopImmediatePropagation();
};